<template>
  <div class="mainImg">
    <img src="../assets/ycb/map.png" />

    <div class="point-area p1">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[0] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>

    <div class="point-area p2">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[1] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>

    <div class="point-area p3">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[2] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>

    <div class="point-area p4">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[3] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>

    <div class="point-area p5">
      <p class="point-name" style="position: absolute; top: 60px; left: 28px">
        {{ $t("map")[4] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>

    <div class="point-area p6">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[5] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>
    <!-- 越南 -->
    <div class="point-area p7">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[6] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>
    <!-- 东南亚 -->
    <div class="point-area p8">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[7] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>
    <!-- 印度 -->
    <div class="point-area p9">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[8] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>
    <!-- 澳大利亚 -->
    <div class="point-area p10">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[9] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>
    <!-- 俄罗斯 -->
    <div class="point-area p11">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[10] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>
    <!-- 巴西 -->
    <div class="point-area p12">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[11] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>
    <!-- 智利 -->
    <div class="point-area p13">
      <p class="point-name" style="position: absolute; top: 28px; left: 60px">
        {{ $t("map")[12] }}
      </p>
      <a class="point point-dot"> </a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mapa",
};
</script>

<style lang="scss" scoped>
.mainImg {
  width: 60%;
  margin-left: 3%;
  font-size: 13px;
  position: relative;
  margin-top: 120px;
  img {
    width: 100%;
    object-fit: cover;
  }
  .point-area {
    text-align: center;
    .point-name {
      font-size: 13px;
      color: white;
      white-space: nowrap;
      text-transform: uppercase;
    }
    .point {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 6px;
      height: 6px;
      margin: auto;
      -webkit-border-radius: 50%;
      -webkit-background-clip: padding-box;
      -moz-border-radius: 50%;
      -moz-background-clip: padding;
      border-radius: 50%;
      background-clip: padding-box;
      background: transparent;
    }
    .point-dot {
      z-index: 1;
      background-color: #00ff65;
      border: 1px solid #00ff65;
    }
    .point-10,
    .point-70，.point-40,
    .point-80 {
      width: 100%;
      height: 100%;
    }
    .point-10::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 50%;
      border: 2px solid #00ff65;
      opacity: 0;
      -webkit-animation: ripple 4500ms ease-out 225ms infinite;
      -moz-animation: ripple 4500ms ease-out 225ms infinite;
      -o-animation: ripple 4500ms ease-out 225ms infinite;
      animation: ripple 4500ms ease-out 225ms infinite;
    }
    .point-70::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 50%;
      border: 2px solid #00ff65;
      opacity: 0;
      -webkit-animation: ripple 4500ms ease-out 1575ms infinite;
      -moz-animation: ripple 4500ms ease-out 1575ms infinite;
      -o-animation: ripple 4500ms ease-out 1575ms infinite;
      animation: ripple 4500ms ease-out 1575ms infinite;
    }
    .point-40::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 50%;
      border: 2px solid #00ff65;
      opacity: 0;
      -webkit-animation: ripple 4500ms ease-out 225ms infinite;
      -moz-animation: ripple 4500ms ease-out 225ms infinite;
      -o-animation: ripple 4500ms ease-out 225ms infinite;
      animation: ripple 4500ms ease-out 225ms infinite;
    }
    .point-80::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 50%;
      border: 2px solid #00ff65;
      opacity: 0;
      -webkit-animation: ripple 4500ms ease-out 1575ms infinite;
      -moz-animation: ripple 4500ms ease-out 1575ms infinite;
      -o-animation: ripple 4500ms ease-out 1575ms infinite;
      animation: ripple 4500ms ease-out 1575ms infinite;
    }
    @-webkit-keyframes ripple {
      0% {
        opacity: 0;
        -webkit-transform: scale(0.1, 0.1);
      }
      5% {
        opacity: 1;
      }
      100% {
        opacity: 0;
        -webkit-transform: scale(1);
      }
    }
    @-moz-keyframes ripple {
      0% {
        opacity: 0;
        -moz-transform: scale(0.1, 0.1);
      }
      5% {
        opacity: 1;
      }
      100% {
        opacity: 0;
        -moz-transform: scale(1);
      }
    }
    @keyframes ripple {
      0% {
        opacity: 0;
        -webkit-transform: scale(0.1, 0.1);
      }
      5% {
        opacity: 1;
      }
      100% {
        opacity: 0;
        -webkit-transform: scale(1);
      }
    }
  }
  .p1 {
    top: 22%;
    left: 13%;
    position: absolute;
    width: 100px;
    height: 100px;
    visibility: visible;
    opacity: 1;
  }
  .p2 {
    top: 7%;
    left: 11%;
    position: absolute;
    width: 100px;
    height: 100px;
    visibility: visible;
    opacity: 1;
  }
  .p3 {
    top: 35%;
    left: 15%;
    position: absolute;
    width: 100px;
    height: 100px;
    visibility: visible;
    opacity: 1;
  }
  .p4 {
    top: 11%;
    left: 45%;
    position: absolute;
    width: 100px;
    height: 100px;
    visibility: visible;
    opacity: 1;
  }
  .p5 {
    top: 12%;
    left: 42%;
    position: absolute;
    width: 140px;
    height: 140px;
    visibility: visible;
    opacity: 1;
  }
  .p6 {
    top: 7%;
    left: 49%;
    position: absolute;
    width: 140px;
    height: 140px;
    visibility: visible;
    opacity: 1;
  }
  .p7 {
    top: 40%;
    left: 73%;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p8 {
    top: 43%;
    left: 76%;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p9 {
    top: 39%;
    left: 66%;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p10 {
    top: 65%;
    left: 82%;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p11 {
    top: 10%;
    left: 65%;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p12 {
    top: 53%;
    left: 29%;
    position: absolute;
    width: 150px;
    height: 150px;
    visibility: visible;
    opacity: 1;
  }
  .p13 {
    top: 75%;
    left: 25%;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p14 {
    top: 200px;
    left: 620px;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p15 {
    top: 200px;
    left: 680px;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p16 {
    top: 200px;
    left: 790px;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p17 {
    top: 200px;
    left: 850px;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p18 {
    top: 230px;
    left: 885px;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p19 {
    top: 370px;
    left: 600px;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  .p20 {
    top: 150px;
    left: 930px;
    position: absolute;
    width: 80px;
    height: 80px;
    visibility: visible;
    opacity: 1;
  }
  @media screen and (max-width: 1000px) {
    margin-left: 0;
    width: 100%;
    margin-top: 20px;
    padding: 30px 0;
    img {
      width: 100%;
    }
    .point-area {
      .point-name {
        font-size: 10px;
      }
    }
  }
}
</style>
